import { render, staticRenderFns } from "./PopTextArea.vue?vue&type=template&id=42adb156&scoped=true&"
import script from "./PopTextArea.vue?vue&type=script&lang=ts&"
export * from "./PopTextArea.vue?vue&type=script&lang=ts&"
import style0 from "./PopTextArea.vue?vue&type=style&index=0&id=42adb156&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42adb156",
  null
  
)

export default component.exports